const ExpandIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={17} fill="none">
    <path
      fill="#fff"
      d="M15 9.765v4.73a.724.724 0 0 1-.723.722H9.55V13.77h2.973L8 9.23 3.478 13.77H6.45v1.446H1.723A.724.724 0 0 1 1 14.494V9.765h1.445v2.974l4.543-4.522-4.543-4.522v2.973H1V1.94c0-.398.324-.722.723-.722H6.45v1.445H3.478L8 7.205l4.522-4.543H9.55V1.217h4.728c.399 0 .723.324.723.722v4.73h-1.445V3.694L9.012 8.217l4.543 4.522V9.765H15Z"
    />
  </svg>
);
export default ExpandIcon;
